/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElButtonModule } from '../button/button.module';
import { ElInputModule } from '../input/input.module';
import { ElIconModule } from '../icon/icon.module';

import { ElChatComponent } from './chat.component';
import { ElChatMessageComponent } from './chat-message.component';
import { ElChatFormComponent } from './chat-form.component';
import { ElChatMessageTextComponent } from './chat-message-text.component';
import { ElChatMessageFileComponent } from './chat-message-file.component';
import { ElChatMessageQuoteComponent } from './chat-message-quote.component';
import { ElChatMessageMapComponent } from './chat-message-map.component';
import { ElChatOptions } from './chat.options';

const EL_CHAT_COMPONENTS = [
  ElChatComponent,
  ElChatMessageComponent,
  ElChatFormComponent,
  ElChatMessageTextComponent,
  ElChatMessageFileComponent,
  ElChatMessageQuoteComponent,
  ElChatMessageMapComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
    ElIconModule,
    ElInputModule,
    ElButtonModule,
  ],
  declarations: [
    ...EL_CHAT_COMPONENTS,
  ],
  exports: [
    ...EL_CHAT_COMPONENTS,
  ],
})
export class ElChatModule {

  static forRoot(options?: ElChatOptions) {
    return <ModuleWithProviders> {
      ngModule: ElChatModule,
      providers: [
        { provide: ElChatOptions, useValue: options || {} },
      ],
    };
  }

  static forChild(options?: ElChatOptions) {
    return <ModuleWithProviders> {
      ngModule: ElChatModule,
      providers: [
        { provide: ElChatOptions, useValue: options || {} },
      ],
    };
  }
}
